"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _googleAnalytics = require("../utils/googleAnalytics");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* global ga */
var sendEvent = function sendEvent(type) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  ga(_constants.GA_SEND, _objectSpread(_objectSpread({}, payload), {}, {
    hitType: type
  }));
};
var set = (0, _googleAnalytics.withGA)(function (key, value) {
  ga(_constants.GA_SET, key, value);
});

/*
  eventCategory    text       yes      Typically the object that was interacted with (e.g. 'Video')
  eventAction      text       yes      The type of interaction (e.g. 'play')
  eventLabel       text       no       Useful for categorizing events (e.g. 'Fall Campaign')
  eventValue       integer    no       A numeric value associated with the event (e.g. 42)
*/
var send = (0, _googleAnalytics.withGA)(function (type, payload) {
  sendEvent(type, payload);
});
var sendWithClientId = (0, _googleAnalytics.withGA)(function (type, payload) {
  ga(function (tracker) {
    var clientId = tracker.get(_constants.GA_CLIENTID);
    sendEvent(type, _objectSpread(_objectSpread({}, payload), {}, {
      eventAction: clientId
    }));
  });
});
var createScript = function createScript(event, key, value) {
  return "ga(\"".concat(event, "\", \"").concat(key, "\", \"").concat(value, "\")");
};
var createSetScript = function createSetScript(key, value) {
  return createScript(_constants.GA_SET, key, value);
};
var _default = {
  set: set,
  send: send,
  isEnabled: _googleAnalytics.hasGA,
  sendWithClientId: sendWithClientId,
  createSetScript: createSetScript
};
exports.default = _default;
//# sourceMappingURL=GoogleAnalyticsConnector.js.map